export const GET_CAMPAIGN_REQUEST = 'profile/GET_CAMPAIGN_REQUEST';
export const GET_CAMPAIGN_FAILURE = 'profile/GET_CAMPAIGN_FAILURE';
export const GET_CAMPAIGN_SUCCESS = 'profile/GET_CAMPAIGN_SUCCESS';

export const GET_REFERRAL_LINK_REQUEST = 'profile/GET_REFERRAL_LINK_REQUEST';
export const GET_REFERRAL_LINK_FAILURE = 'profile/GET_REFERRAL_LINK_FAILURE';
export const GET_REFERRAL_LINK_SUCCESS = 'profile/GET_REFERRAL_LINK_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/constants.js